import { useState } from "react";
import { Button, Checkbox, Flex, Text } from "@/ui";
import NavigationBar from "@/components/NavigationBar";
import AppImage from "@/components/AppImage";
import { t } from "@/utils";
import type { WizardProps } from "../Wizard";

const USE_CASE_KEYS = {
  0: "live-video",
  1: "secure-home",
  2: "check-on-baby",
  3: "check-on-dog",
  4: "senior-care",
  5: "other"
};
const USE_CASE_COUNT = 6;
type UseCaseKey = keyof typeof USE_CASE_KEYS;

export default function CameraUsage({ next, previous }: WizardProps) {
  const [selected, setSelected] = useState<UseCaseKey[]>([0]);

  const toggle = (index: UseCaseKey) => {
    setSelected((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
  };

  return (
    <Flex grow={1} direction="column" alignItems="center" position="relative">
      <NavigationBar title={t("cameraCustomization.step3.title")} onBack={() => previous()} props={{ mb: "8" }} />

      <Flex gap="16" mt="62" grow={1} flexWrap="wrap" alignContent="flex-start">
        {Array.from({ length: USE_CASE_COUNT }).map((_, index) => {
          return (
            <Button
              key={index}
              variant="unstyled"
              display="flex"
              textAlign="left"
              bg="secondary-container"
              gap="16"
              alignItems="center"
              p="16"
              borderRadius="24"
              flexBasis="calc(50% - 8px)"
              minW={0}
              whiteSpace="normal"
              cursor="pointer"
              onClick={() => toggle(index as UseCaseKey)}
            >
              <Flex w="48px" h="48px" alignItems="center" justifyContent="center" flexShrink={0}>
                <AppImage name={`usecase${index + 1}.svg`} options={{ imgProps: { w: "48px", h: "48px" } }} />
              </Flex>
              <Text flex={1} fontWeight="600" userSelect="none">
                {t(`usecase${index + 1}` as StringKey)}
              </Text>
              <Checkbox isChecked={selected.includes(index as UseCaseKey)} pointerEvents="none" />
            </Button>
          );
        })}
      </Flex>
      <Button
        bg="primary"
        color="on-primary"
        minW="18.5rem"
        disabled={selected.length === 0}
        onClick={() =>
          next({
            stateUpdate: {
              cameraUseCases: selected.map((index) => USE_CASE_KEYS[index])
            }
          })
        }
      >
        {t("buttons.continue")}
      </Button>
    </Flex>
  );
}
